import * as Legacy from './legacy'

export { Legacy }
export * from './inquiry-user'
export * from './listing-inquiry'
export * from './multipost-listing-inquiry'
export * from './rental-inquiry'
